// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606191130/js/" + chunkId + "." + {"44":"a70e0318","225":"0c515e64","481":"37d4dbfa","486":"9a3e0c4e","770":"068dfa76"}[chunkId] + ".0.14161615085131962.chunk.js";
};